import cn from "@utils/cn";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import FocusLock from "react-focus-lock";

interface Props {
  children: ReactNode;
  className?: string;
  removePadding?: boolean;
}
export type ModalContentType = typeof ModalContent;
const ModalContent: FC<Props> = ({ children, className, removePadding = false }) => {
  const modalContent = useRef<HTMLDivElement>(null);
  const [roundedBorder, setRoundedBorder] = useState(true);
  useEffect(() => {
    if (window && modalContent.current && modalContent.current.clientHeight >= window.innerHeight) {
      setRoundedBorder(false);
    }
  }, []);
  return (
    <div
      ref={modalContent}
      className={cn(
        "bg-white overflow-auto max-h-dvh md:rounded-2xl relative",
        roundedBorder && "rounded-t-2xl",
        !removePadding ? "px-l" : "",
        className && className,
      )}
    >
      <FocusLock returnFocus={true}>
        <>{children}</>
      </FocusLock>
    </div>
  );
};
export default ModalContent;
